import {Component, inject, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ErrorService } from '../../../../core/services/error.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthenticationService} from '../../authentication.service';
import {AuthenticationMapper} from '../../mappers/authentication.mapper';
import {IconButtonComponent} from '../../../../shared/components/icon-button/icon-button.component';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {AuthenticationFormFactory} from '../../factories/authentication-form.factory';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-set-password',
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    TranslocoPipe,
    IconButtonComponent,
    TextButton
  ],
  templateUrl: './set-password.component.html',
  styleUrl: './set-password.component.scss'
})
export class SetPasswordComponent implements OnInit{
  authenticationService: AuthenticationService = inject(AuthenticationService);
  fb: FormBuilder = inject(FormBuilder);
  translocoService = inject(TranslocoService);
  errorService = inject(ErrorService);
  error?: string;
  setPasswordForm!: FormGroup;
  hidePassword: boolean = true;
  hidePasswordRepeat: boolean = true;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private snackBar: MatSnackBar) {
  }

  get isPasswordValid() {
    return this.setPasswordForm.get('password')?.valid || !this.setPasswordForm.get('password')?.touched;
  }

  get isPasswordRepeatValid() {
    return this.setPasswordForm.get('passwordRepeat')?.valid || !this.setPasswordForm.get('passwordRepeat')?.touched;
  }

  get passwordMatch() {
    return this.setPasswordForm.hasError("passwordMatch")
  }

  ngOnInit() {
    this.setPasswordForm = AuthenticationFormFactory.createSetPasswordForm(this.fb);
    let urlParameter = this.activatedRoute.snapshot.queryParams['verificationCode'];
    if (urlParameter) {
      this.setPasswordForm.patchValue({verificationCode: urlParameter});
    }
  }

  setPassword() {
    this.setPasswordForm.markAllAsTouched();
    if (this.setPasswordForm.invalid) {
      return;
    }

    const setPasswordDto = AuthenticationMapper.toSetPasswordDto(this.setPasswordForm.value);
    this.authenticationService.setPassword(setPasswordDto).subscribe({
      next: () => {
        this.error = undefined;
        this.snackBar.open(this.translocoService.translate('passwordReset.succeeded'), 'OK', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom'
        });
        this.router.navigate(['/profile']);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 400) {
          this.error = this.translocoService.translate('error.verificationCode');
          return;
        }

        this.error = undefined;
        this.errorService.handleError(error, this.translocoService.translate('error.title.appointments'));
      }
    })
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  togglePasswordRepeatVisibility() {
    this.hidePasswordRepeat = !this.hidePasswordRepeat;
  }
}
